var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 30",
    style: {
      enableBackground: "new 0 0 19 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.5;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,0.3L13.3,0.3c1.4,0,2.9,0.1,4.3,0.2c0.2,0,0.4,0.2,0.4,0.5v0v4.9c0,0.3-0.2,0.5-0.5,0.5h0l-2.9,0 c0,0,0,0,0,0c-0.9,0-1.5,0.1-1.8,0.5c-0.4,0.4-0.4,1-0.4,1.7v2.8v0.2h0.2h4.7c0,0,0,0,0.1,0c0.3,0,0.4,0.3,0.4,0.5v0L17,17.5 c0,0.2-0.2,0.4-0.5,0.4l0,0h-4h-0.2v0.2v10.9c0,0.3-0.2,0.5-0.5,0.5h0H6.2c-0.3,0-0.5-0.2-0.5-0.5v0V18.1v-0.2H5.5h-4 c-0.3,0-0.5-0.2-0.5-0.5v0V12c0-0.3,0.2-0.5,0.5-0.5h0h4h0.2v-0.2V8c0-2.4,0.7-4.3,2-5.6C9.1,1,10.9,0.3,13.3,0.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footer-facebook.1cf331f9cbde80be9f03f912b9453b25.svg";
export { ForwardRef as ReactComponent };